// extracted by mini-css-extract-plugin
module.exports = {"root":"mui_select_menue-item_root__1f8Vv","selected":"mui_select_menue-item_selected__3EFGM"};